export default __webpack_public_path__ + "static/media/veedeo.8b1c9015.png";